import { carouselItems } from '@/mocks/home';

export default function CarouselSection() {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
  };

  return (
    <section id="carousel" className="w-full py-12 md:py-16 bg-background-100/70">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 tracking-wide">
            焦点专题
          </h2>
          <p className="mt-3 text-sm text-foreground-600 max-w-lg mx-auto">
            精选深度影视专题，为您呈现精彩内容
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {carouselItems.map((item, idx) => (
            <a
              key={idx}
              href="#carousel"
              onClick={handleClick}
              className="group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden cursor-pointer no-underline transition-all duration-200 hover:border-primary-300/50 flex flex-col"
            >
              <div className="relative w-full aspect-[4/3] overflow-hidden">
                <img
                  src={item.image}
                  alt={`51影院 - ${item.title}`}
                  title={`51影院${item.title}`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-2 left-2">
                  <span className="px-2 py-0.5 bg-accent-500 text-white text-xs rounded-md font-medium">
                    {item.tag}
                  </span>
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
                <div className="absolute bottom-3 left-3 right-3">
                  <div className="text-white text-sm font-semibold leading-tight line-clamp-1">
                    {item.title}
                  </div>
                </div>
              </div>
              <div className="p-3 md:p-4 flex-1 flex flex-col">
                <p className="text-xs text-foreground-500 mb-2">{item.subtitle}</p>
                <p className="text-xs text-foreground-600 leading-relaxed line-clamp-3 flex-1">
                  {item.description}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}